import { Component, Input, OnChanges, SimpleChanges, input } from '@angular/core';
import { InciteMetricsDTO } from '../../../shared/external-model/incitemetrics/incite-metrics-dto';
import { PortalEsploroConfiguration } from '../../../shared/interfaces/research-portal/portal-configuration/portal-esploro-configuration';
import { TranslateModule } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';
import { MatCard } from '@angular/material/card';
import { TitleCasePipe } from '@angular/common';

@Component({
    selector: 'esp-incites-highlights',
    templateUrl: './incites-highlights.component.html',
    styleUrls: ['./incites-highlights.component.scss'],
    imports: [
        MatCard,
        MatIcon,
        TranslateModule,
        TitleCasePipe
    ]
})
export class IncitesHighlightsComponent implements OnChanges {
    readonly data = input<InciteMetricsDTO>(undefined);
    _hasCollabs = false;
    _hasTagsData = false;
    _showTagsArea = false;
    configMap: { [key: string]: PortalEsploroConfiguration } = {};

    _config: PortalEsploroConfiguration[];

    get config() {
        return this._config;
    }

    // TODO: Skipped for migration because:
    //  Accessor inputs cannot be migrated as they are too complex.
    @Input() set config(configObjs: PortalEsploroConfiguration[]) {
        configObjs.forEach((configObj) => {
            Object.assign(this.configMap, { [configObj.code]: configObj });
            if (
                [
                    'inciteCollaboration',
                    'inciteCitationTopics',
                    'inciteWOSResearchAreas',
                    'inciteESIResearchAreas',
                ].includes(configObj.code)
            ) {
                this._showTagsArea = this._showTagsArea || configObj.active;
            }
        });
        this._config = configObjs;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['data'] && changes['data'].currentValue) {
            const data = changes['data'].currentValue as InciteMetricsDTO;
            this._hasCollabs =
                data.institutionCollaboration ||
                data.industryCollaboration ||
                data.internationalCollaboration;

            this._hasTagsData =
                this._hasCollabs ||
                data.metricsValueMap?.ct?.filter((_) => _.subject).length > 0 ||
                data.metricsValueMap?.wos?.filter((_) => _.subject).length >
                    0 ||
                data.metricsValueMap?.esi?.filter((_) => _.subject).length > 0;
        }
    }
}
